import React from 'react';
import { Link } from 'react-router-dom';
import { imageUrl } from '../services/api';

export default function CollectionCard({ label, category, coverProduct, accent, featured, href }) {
  const img = coverProduct ? imageUrl(coverProduct.imagen) : null;
  const tone = accent || 'var(--brand-hot)';
  const to = href || `/catalogo?cat=${encodeURIComponent(category)}`;

  return (
    <Link
      to={to}
      className={`collection-card${featured ? ' featured' : ''}${img ? ' has-image' : ''}`}
      style={
        img
          ? {
              backgroundImage: `linear-gradient(165deg, rgba(24,24,27,.08) 10%, rgba(24,24,27,.72) 78%), url(${img})`,
            }
          : { '--collection-accent': tone }
      }
    >
      <span className="collection-accent" style={{ background: tone }} />
      <div className="collection-copy">
        <strong>{label}</strong>
        <em>Explorar colección →</em>
      </div>
    </Link>
  );
}
